var PromoBar = class extends HTMLElement {
	constructor() {
		super();
		this.cartData = null;
		this.prices = this.querySelectorAll(".item__price");
		this.labels = this.querySelectorAll(".item__label");
		this.markers = this.querySelectorAll(".item__marker");
		this.bar = this.querySelector(".bar");
		this.barTrack = this.querySelector(".bar__track");
		this.toReachNextGoal = this.querySelector('[role="to-reach-next-goal"]');
		this.nextGoalLabel = this.querySelector('[role="next-goal-label"]');
		this.currency = this.dataset.currency;
	}
	connectedCallback() {
		fetch(`${Shopify.routes.root}cart.js`)
			.then((res) => res.json())
			.then((res) => {
				this.cartData = res;
				this.calculateBarPosition();
			});
	}

	calculateBarPosition() {
		let prices = [];
		const cartPrice = this.cartData.total_price / 100;
		this.prices.forEach((price) => {
			const priceNumber = +price.innerHTML.replace(this.currency, "");
			prices.push(priceNumber);

			cartPrice >= priceNumber
				? price.closest(".item").classList.add("active")
				: price.closest(".item").classList.remove("active");
		});

		const percent = 100 / prices.length;
		const halfPercent = percent / 2;
		let lastPercent = 0;

		for (let i = 0; i < prices.length; i++) {
			const price = prices[i];
			if (cartPrice >= price) {
				lastPercent += i == 0 ? halfPercent : percent;
				if (i >= prices.length - 1) {
					this.barTrack.style.width = `100%`;
					this.toReachNextGoal.innerHTML = `${(0).toFixed(2)}${this.currency}`;
				}
			} else {
				if (i == 0) {
					this.barTrack.style.width = `${(cartPrice * halfPercent) / price}%`;
				} else {
					const priceRange = price - prices[i - 1];
					const totalToCompare = cartPrice - prices[i - 1];
					const rangePercent = (totalToCompare * percent) / priceRange;
					this.barTrack.style.width = `${rangePercent + lastPercent}%`;
				}
				this.toReachNextGoal.innerHTML = `${(price - cartPrice).toFixed(2)}${
					this.currency
				}`;
				this.nextGoalLabel.innerHTML = `${this.labels[i].dataset.connector} ${this.labels[i].innerHTML}`;
				break;
			}
		}
	}
};
if (!window.customElements.get("promo-bar")) {
	window.customElements.define("promo-bar", PromoBar);
}

var backToTop = class extends HTMLElement {
	constructor() {
		super();
		this.scroll = window.scrollY;
	}
	connectedCallback() {
		window.addEventListener("scroll", this.checkScrollPosition.bind(this));
		this.addEventListener("click", this.backToTop);
		this.checkScrollPosition.bind(this);
	}

	checkScrollPosition() {
		this.scroll = window.scrollY;
		if (this.scroll >= 100) {
			this.classList.add("visible");
		} else {
			this.classList.remove("visible");
		}
	}

	backToTop() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	}
};
if (!window.customElements.get("back-to-top")) {
	window.customElements.define("back-to-top", backToTop);
}

var fidelityBanner = class extends HTMLElement {
	constructor() {
		super();

		this.trigger = this.querySelector(".fidelity-banner__logged-in button");
		this.modal = this.querySelector(".fidelity-banner__modal");
		this.modalClose = this.querySelector(".fidelity-banner__modal-close");
		this.modalOverlay = this.querySelector(".fidelity-banner__modal-overlay");

		this.loader = this.querySelector(".fidelity-banner__modal-loader");
		this.history = this.querySelector(".fidelity-banner__history-wrapper");
		this.firstRow = this.querySelector(".fidelity-banner__history-header");
		this.emptyRow = this.querySelector(".fidelity-banner__history-empty");
	}

	connectedCallback() {
		if (!this.modal) return;

		this.trigger.addEventListener("click", this.openModal.bind(this));
		this.modalClose.addEventListener("click", this.closeModal.bind(this));
		this.modalOverlay.addEventListener("click", this.closeModal.bind(this));
		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") this.closeModal();
		});
	}

	openModal() {
		this.modal.classList.add("open");

		this.fetchCustomerDetails();
	}

	closeModal() {
		this.modal.classList.remove("open");
	}

	async fetchCustomerDetails() {
		const email = this.dataset.customerEmail;
		this.toggleLoader("on");
		this.emptyRow.classList.add("hidden");

		await fetch(`/apps/proxy-yotpo?mail=${email}`, {
			method: "GET",
			headers: {
				accept: "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((res) => {
				this.updateCustomerDetails(res.data);
			})
			.catch((err) => console.error(err));
	}

	updateCustomerDetails(data) {
		this.history.innerHTML = "";
		const items = data.history_items;

		this.toggleLoader("off");

		if (items && items.length > 0) {
			this.firstRow.classList.remove("hidden");
		} else {
			this.emptyRow.classList.remove("hidden");
			return;
		}

		items.forEach((item) => {
			const creation = new Date(item.created_at);
			const creationFormatted = creation.toLocaleDateString("fr-FR");

			const expiration = new Date(item.created_at);
			expiration.setFullYear(expiration.getFullYear() + 1);
			const expirationFormatted = expiration.toLocaleDateString("fr-FR");

			const div = document.createElement("div");
			div.classList.add("fidelity-banner__history-row");
			div.innerHTML = `
				<p>${item.action}</p>
				<p>${item.points}</p>
				<p>${creationFormatted}</p>
				<p>${
					item.status === "Approved"
						? this.dataset.modalApprovedText
						: item.status
				}</p>
				<p>${expirationFormatted}</p>
			`;

			this.history.appendChild(div);
		});
	}

	toggleLoader(action) {
		action === "on"
			? this.loader.classList.remove("hidden")
			: this.loader.classList.add("hidden");
	}
};
if (!window.customElements.get("fidelity-banner")) {
	window.customElements.define("fidelity-banner", fidelityBanner);
}
